// extracted by mini-css-extract-plugin
export default {"rowText":"PostedInfoRow_rowText__03Raw"};